export const getStyles = (theme) => ({
    sidebar: {
        height: '100%',
        width: '85px',
        backgroundColor: theme.palette.sidebar.background,
        position: 'fixed',
        color: theme.palette.sidebar.text,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRight: `1px solid ${theme.palette.sidebar.border}`,
        zIndex: 900,
        [theme.breakpoints.down('md')]: {
            width: '56px',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    }
});
